import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTheme } from "@mui/material/styles";

const NotFoundPage = () => {
  const theme = useTheme();
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        width: "100vw",
        bgcolor: "background.default",
        color: "text.primary",
        textAlign: "center",
        position: "relative",
        overflow: "hidden", // Evita overflow
        p: 2, // Padding global
        boxSizing: "border-box",
      }}
    >
      {/* Fundo com Gradiente */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          background: `linear-gradient(135deg, ${theme.palette.primary.light} 0%, ${theme.palette.secondary.dark} 100%)`,
          zIndex: 0,
        }}
      />

      {/* MT*/}
      <Box
        sx={{
          position: "absolute",
          width: 250,
          height: 250,
          borderRadius: "50%",
          background: theme.palette.mode === "light"
            ? "rgba(255, 255, 255, 0.2)"
            : "rgba(0, 0, 0, 0.3)",
          top: "10%",
          left: "10%",
          zIndex: 1,
          animation: "move-1 10s infinite alternate ease-in-out",
        }}
      />
      <Box
        sx={{
          position: "absolute",
          width: 350,
          height: 350,
          borderRadius: "50%",
          background: theme.palette.mode === "light"
            ? "rgba(255, 255, 255, 0.2)"
            : "rgba(0, 0, 0, 0.3)",
          bottom: "15%",
          right: "15%",
          zIndex: 1,
          animation: "move-2 12s infinite alternate ease-in-out",
        }}
      />

      {/* Conteúdo Principal */}
      <Box
        sx={{
          zIndex: 2,
          p: 4,
          bgcolor: "rgba(255, 255, 255, 0.9)",
          borderRadius: 3,
          boxShadow: 6,
          maxWidth: "600px",
          width: "100%",
          textAlign: "center",
          mx: 2,
          boxSizing: "border-box",
        }}
      >
        <Typography
          variant="h1"
          color="primary"
          sx={{
            fontSize: { xs: "4rem", sm: "6rem" },
            fontWeight: "bold",
          }}
          gutterBottom
        >
          404
        </Typography>
        <Typography
          variant="h5"
          sx={{
            mb: 2,
            fontSize: { xs: "1.2rem", sm: "1.5rem" },
            color: "text.secondary",
          }}
        >
          Opa! Parece que você se perdeu. 
        </Typography>
        <Typography
          variant="body1"
          sx={{
            mb: 4,
            color: "text.secondary",
          }}
        >
          a página que você está procurando não existe ou foi movida.
        </Typography>
        <Button
          variant="contained"
          color="primary"
          onClick={() => navigate("/")}
          sx={{
            textTransform: "uppercase",
            fontWeight: "bold",
            px: 4,
            py: 1.5,
            boxShadow: 4,
            "&:hover": {
              boxShadow: 6,
            },
          }}
        >
          Voltar para a Home
        </Button>
      </Box>

      {/* Keyframes para animação */}
      <style>
        {`
          @keyframes move-1 {
            0% {
              transform: translate(0, 0);
            }
            100% {
              transform: translate(50px, -50px);
            }
          }
          @keyframes move-2 {
            0% {
              transform: translate(0, 0);
            }
            100% {
              transform: translate(-50px, 50px);
            }
          }
        `}
      </style>
    </Box>
  );
};

export default NotFoundPage;
